import React, { Component as C } from "react"
import PropTypes from "prop-types"
import $ from "jquery"
import Draggable from "react-draggable"
import classnames from "classnames"
import baseRowStyles from "../../common-styles/styles.less"
import styles from "./selectable-draggable-row.less"
import jss from "jss"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import { toJss, darken } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"

class SelectableDraggableRow extends C {
  static dynamicStyles = null
  static displayName = "SelectableDraggableRow"

  static propTypes = {
    key: PropTypes.string,
    className: PropTypes.string,
    container: PropTypes.string,
    insideContainerAction: PropTypes.func,
    outsideContainerAction: PropTypes.func,
  }

  static defaultProps = {
    container: "",
    insideContainerAction() {},
    outsideContainerAction() {},
  }

  constructor(props) {
    super(props)

    if (SelectableDraggableRow.dynamicStyles == null) {
      const dynamicStylesConfig = toJss((props.skinObject.table || {}).row || {}, {
        tr: {
          color: v.black,
        },
      })

      SelectableDraggableRow.dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()
    }
  }

  isTargetInPosition(e) {
    var containerSelector = this.props.container
    $(containerSelector).removeClass("drag-n-drop-highlighted")
    var containerOffsetTop = $(containerSelector).offset().top
    var containerOffsetBottom =
      $(containerSelector).offset().top + $(containerSelector).outerHeight()
    var targetOffset = $(e.target).offset().top
    return containerOffsetTop < targetOffset && targetOffset < containerOffsetBottom
  }

  onStop(e) {
    $(".drag-n-drop-disabled").attr("disabled", false)
    if (this.isTargetInPosition(e)) {
      this.props.insideContainerAction()
    } else {
      this.props.outsideContainerAction()
    }
  }

  onDrag(e) {
    if (this.isTargetInPosition(e)) $(this.props.container).addClass("drag-n-drop-highlighted")
    else $(this.props.container).removeClass("drag-n-drop-highlighted")
  }

  onStart(e) {
    var $draggable = $(e.target).hasClass("react-draggable")
      ? $(e.target)
      : $(e.target).closest(".react-draggable")

    $draggable.css({
      position: "absolute",
      "z-index": 9999,
    })
    $(".drag-n-drop-disabled").attr("disabled", true)
  }

  render() {
    let { classes } = SelectableDraggableRow.dynamicStyles
    let className = classnames(baseRowStyles.tr, classes.tr, styles.tr, this.props.className)

    return (
      <Draggable
        axis="y"
        onStart={this.onStart.bind(this)}
        onDrag={this.onDrag.bind(this)}
        onStop={this.onStop.bind(this)}>
        <div key={this.props.key} className={className} onClick={this.props.onClick}>
          {this.props.children}
        </div>
      </Draggable>
    )
  }
}

export default withSkin(SelectableDraggableRow)
